module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/ant-star4.44d096cd.png";